/**
 * WorkItem Type Tab Buttons
 */

export enum WorkItemTypeTabButtons {
    /**
     * Represents a constant string identifier for the  WorkItem Type Tab MoveUp
     */
    WORK_ITEM_TYPE_TAB_MOVE_UP = "WorkItemTypeTabMoveUp",

    /**
     * Represents a constant string identifier for the WorkItem Type Tab MoveDown
     */
    WORK_ITEM_TYPE_TAB_MOVE_DOWN = "WorkItemTypeTabMoveDown",

}
